import React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';

import { getCategoryFromJob } from '../../../lib/greenHouse/greenHouseApi';

const JobCard = styled(Card)`
  position: relative;
  min-width: 350px;
  height: 220px;
  margin: 1rem;
  padding: 1rem;
  border: 1px solid ${({ theme }) => theme.palette.primary.main};
  flex: 0 1 auto;
  width: 350px;
  border-radius: 0.5rem;

  ${(props) => props.theme.breakpoints.up('md')} {
    width: 400px;
  }

  ${(props) => props.theme.breakpoints.up('lg')} {
    width: 500px;
  }
`;

const DetailButton = styled(Button)`
  position: absolute;
  bottom: 1rem;
  left: 1rem;
`;

export const JobListEntry = ({
  handler,
  job,
}: {
  handler: any;
  job: any;
}): JSX.Element => {
  const handleButtonClick = () => {
    // Add the id and propagate it to the parent
    handler(job.id);
  };

  return (
    <JobCard>
      <Typography variant="h4">{job.title}</Typography>

      <p>
        Typ: {getCategoryFromJob(job)}, Ort: {job.location?.name}
      </p>
      <DetailButton
        variant="contained"
        color="primary"
        onClick={handleButtonClick}
      >
        Details ansehen
      </DetailButton>
    </JobCard>
  );
};
